
/**
 * 定义一些常量
 */

//年月日的中文字符
export const CONST_YEAR_WORD = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
export const CONST_MONTH_WORD = ["正月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "腊月"];
export const CONST_DAY_WORD = ["初一", "初二", "初三", "初四", "初五", "初六", "初七", "初八", "初九", "初十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十", "二十一", "二十二", "二十三", "二十四", "二十五", "二十六", "二十七", "二十八", "二十九", "三十", "三十一"];
// 十二时辰
export const CONST_HOUR_WORD = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
// 十二节
export const CONST_MONTH_FEST = ['立春', '惊蛰', '清明', '立夏', '芒种', '小暑', '立秋', '白露', '寒露', '立冬', '大雪', '小寒'];

//五行
export const CONST_WU_XING = "水木火土金";
export const CONST_WU_XING_EN = ["water", "wood", "fire", "soil", "gold"];
//天干
// export const CONST_TIAN_GAN = "0123456789";
export const CONST_TIAN_GAN = "甲乙丙丁戊己庚辛壬癸";
//地支
export const CONST_DI_ZHI = "子丑寅卯辰巳午未申酉戌亥";
//生肖
export const CONST_SHENG_XIAO = "鼠牛虎兔龙蛇马羊猴鸡狗猪";
//藏干
// export const CONST_CANG_GAN = ["癸", "己癸辛", "甲丙戊", "乙", "戊乙癸", "丙庚戊", "丁己", "己丁乙", "庚壬戊", "辛", "戊辛丁", "壬甲"];
export const CONST_CANG_GAN = [[9], [5,9,7], [0,2,4], [1], [4,1,9], [2,6,4], [3,5], [5,3,1], [6,8,4], [7], [4,7,3], [8,0]];


// 命局强弱
export const CONST_STRONG = ['身强', '身弱']
// 命局格局
export const CONST_SITUATION = ['印重局', '命旺局', '伤官局', '财旺局', '煞重局']


//四柱起盘:起始年份
export const CONST_START_END_YEAR = [5, 2100];

//八字分享:随机八字名
export const CONST_SHARE_NAME_LIST = ['私密八字', '隐私八字', '绝密八字', '保密八字', '秘密八字', '隐秘八字', '隐密八字', '机密八字'];

//基础设置:干支十神
export const CONST_SHISHEN_SHOW_TYPES = ['干支', '十神', '藏干', '五行'];

// 百科顶部按钮不同状态下的按钮值
export const CONST_FAMOUS_PEDIA_EDIT_TYPE = {
    modify: 'modify',
    check: 'check',
    edit: 'edit',
    read: 'read'
}